import styled from 'styled-components';

import Logo from '@assets/images/aboutUs/logo_35.svg';

export const LogoImg = styled(Logo)`
    display:block;
    margin-left: auto;
`;